/**
 * Gera um gradiente de cores entre duas cores HEX, com suporte a opacidade.
 *
 * @param {string} startHex - Cor inicial em formato hexadecimal (ex: "#00FF00").
 * @param {string} endHex - Cor final em formato hexadecimal (ex: "#FF0000").
 * @param {number} steps - Quantidade de cores a gerar (mínimo 2).
 * @param {number} [opacity=1] - Opacidade entre 0 e 1 (padrão = 1).
 * @returns {string[]} Lista de cores no formato rgba(r, g, b, a).
 *
 */
export function generateColorGradient(startHex, endHex, steps, opacity = 1) {
  const cleanHex = (hex) => hex.replace("#", "");

  const start = cleanHex(startHex);
  const end = cleanHex(endHex);

  // Converte HEX -> RGB
  const startRGB = {
    r: parseInt(start.substring(0, 2), 16),
    g: parseInt(start.substring(2, 4), 16),
    b: parseInt(start.substring(4, 6), 16),
  };

  const endRGB = {
    r: parseInt(end.substring(0, 2), 16),
    g: parseInt(end.substring(2, 4), 16),
    b: parseInt(end.substring(4, 6), 16),
  };

  const colors = [];

  for (let i = 0; i < steps; i++) {
    const t = i / (steps - 1); // fração entre 0 e 1
    const r = Math.round(startRGB.r + (endRGB.r - startRGB.r) * t);
    const g = Math.round(startRGB.g + (endRGB.g - startRGB.g) * t);
    const b = Math.round(startRGB.b + (endRGB.b - startRGB.b) * t);
    colors.push(`rgba(${r},${g},${b},${opacity})`);
  }

  return colors;
}

// Exemplo de uso:
